import type { TCsvType } from 'App/data-export/components/_utils/createAndDownloadCsvIfApplicable/createCsv'
import { translate } from 'i18n/i18n'

export const mapCsvTypeToFieldAssetTypeFilename: Record<TCsvType, () => string> = {
  blocks: () => translate.phrases.banyanApp('Blocks'),
  irrigationZones: () => translate.phrases.banyanApp('Irrigation Zones'),
  points: () => translate.phrases.banyanApp('Devices'),
}
